import React from "react";
import ContactUs from "../components/contact/ContactUs";

const ContactSection = () => {
  return (
    <section>
  <ContactUs />
    </section>
  );
};

export default ContactSection;
